import * as React from 'react';
import { cn } from '../../lib/utils';

export type RowProps = React.HTMLAttributes<HTMLDivElement>;

const Row = React.forwardRef<HTMLDivElement, RowProps>(({ className, children, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-wrap -mx-1 mb-5', className)} {...props}>
    {children}
  </div>
));
Row.displayName = 'Row';

export { Row };
